import { FETCHSTORE } from "../constants/storeContants";
import * as api from "../../api/index";
import { store } from "../../api/index";

export const getStoreInfo = () => async (dispatch) => {
  try {
    const { data } = await api.getStore(store);
    dispatch({ type: FETCHSTORE, payload: data });
  } catch (error) {
    console.log(error);
  }
};
